import Cookies from "js-cookie";

// Helper function to check if JWT token is expired
const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp * 1000; // Convert to milliseconds
    return Date.now() >= exp;
  } catch (error) {
    return true; // If we can't parse, consider it expired
  }
};

// Helper function to get user from storage (localStorage preferred for mobile, cookie as fallback)
const getUserFromStorage = () => {
  try {
    // Try localStorage first (more reliable on mobile/PWA)
    const localUser = localStorage.getItem("user");
    if (localUser) {
      const parsed = JSON.parse(localUser);
      // Check if token is expired
      if (parsed.token && isTokenExpired(parsed.token)) {
        // Token expired, clear storage
        localStorage.removeItem("user");
        Cookies.remove("user");
        return null;
      }
      return parsed;
    }
    
    // Fallback to cookie
    const cookieUser = Cookies.get("user");
    if (cookieUser) {
      const parsed = JSON.parse(cookieUser);
      // Check if token is expired
      if (parsed.token && isTokenExpired(parsed.token)) {
        // Token expired, clear storage
        localStorage.removeItem("user");
        Cookies.remove("user");
        return null;
      }
      // Sync to localStorage for future use
      localStorage.setItem("user", JSON.stringify(parsed));
      return parsed;
    }
    
    return null;
  } catch (error) {
    console.error("Error reading user from storage:", error);
    // Clear corrupted data
    localStorage.removeItem("user");
    Cookies.remove("user");
    return null;
  }
};

export function userReducer(
  state = getUserFromStorage(),
  action
) {
  switch (action.type) {
    case "LOGIN":
      // Save to both cookie and localStorage
      Cookies.set("user", JSON.stringify(action.payload), { expires: 7 });
      localStorage.setItem("user", JSON.stringify(action.payload));
      return action.payload;
    case "LOGOUT":
      // Clear both cookie and localStorage
      Cookies.remove("user");
      localStorage.removeItem("user");
      return null;
    case "UPDATEPICTURE":
      const updatedUser = { ...state, picture: action.payload };
      // Update both storage locations
      Cookies.set("user", JSON.stringify(updatedUser), { expires: 7 });
      localStorage.setItem("user", JSON.stringify(updatedUser));
      return updatedUser;
    case "VERIFY":
      const verifiedUser = { ...state, verified: action.payload };
      // Update both storage locations
      Cookies.set("user", JSON.stringify(verifiedUser), { expires: 7 });
      localStorage.setItem("user", JSON.stringify(verifiedUser));
      return verifiedUser;

    default:
      return state;
  }
}
